<template>
  <div class="i-footer">
    <p class="byP">{{$t("index.copyright")}}</p>
  </div>
</template>
<script>
export default {
  components: {}
};
</script>

<style lang="scss">
.i-footer {
  width: 100%;
  // height: 200px;
  text-align: center;
  margin: 0 auto;
  // display: inline-block;
  background: #1e2736;
  position: relative;
  .f-con {
    text-align: center;
    display: inline-block;
    margin-top: 50px;
    .qq {
      position: relative;
      .qqImg {
        width: 120px;
        z-index: 6;
        position: absolute;
        left: 37px;
        bottom: 55px;
      }
    }
    .wechat {
      position: relative;
      .wechatImg {
        display: none;
        width: 120px;
        z-index: 6;
        position: absolute;
        left: -40px;
        bottom: 55px;
      }
    }
    .wechat:hover .wechatImg {
      display: inline-block;
    }
    .qq:hover .qqImg {
      display: inline-block;
    }
    .qq {
      position: relative;
      .qqImg {
        display: none;
        width: 120px;
        z-index: 6;
        position: absolute;
        left: -34px;
        bottom: 55px;
      }
    }
    .fDl {
      text-align: center;
      margin-top: 40px;
      float: left;
      margin: auto 15px;
      text-align: center;
      a {
        dt {
          width: 30px;
          height: 30px;
          margin: 0 auto;
          text-align: center;
          img {
            width: 100%;
          }
        }
      }
      dd {
        color: #999;
        font-size: 12px;
        margin: 8px 0 0;
      }
    }
  }
  .byP {
    width: 100%;
    padding: 15px 0;
    text-align: center;
    color: #fff;
    font-size: 12px;
    position: absolute;
    bottom: 0;
    left: 0;
    margin: 0;
    background: #2b3139;
  }
}
</style>




// WEBPACK FOOTER //
// Footer.vue?1bba37a8